<template>
  <div class="poketwitch" :style="pcgThemeStyle">
    <header>
      <div
          v-if="currentViewComponent !== Battle && !battleContent['isViewer']"
          class="text-center pcg-app-nav-container"
      >
        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--pokelist"
            v-bind:title="translation.general.computer"
            :disabled="isLoading || isBlocked || currentView === PokemonList"
            @click="setPokemonListView"
        >
          <svg
              style="width: 27px; height: 27px"
              viewBox="0 0 24 24"
              class="poketwitch__header-btn--pokelist-pokelist"
          >
            <path
                fill="currentColor"
                d="M6,2C4.89,2 4,2.89 4,4V12C4,13.11 4.89,14 6,14H18C19.11,14 20,13.11 20,12V4C20,2.89 19.11,2 18,2H6M6,4H18V12H6V4M4,15C2.89,15 2,15.89 2,17V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V17C22,15.89 21.11,15 20,15H4M8,17H20V20H8V17M9,17.75V19.25H13V17.75H9M15,17.75V19.25H19V17.75H15Z"
            />
          </svg>
        </button>

        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--inventory"
            v-bind:title="translation.general.inventory"
            :disabled="
            isLoading ||
            isBlocked ||
            currentView === ItemList ||
            currentView === ItemShop ||
            currentView === BattleItemShop
          "
            @click="setItemListView"
        >
          <svg
              style="width: 27px; height: 27px"
              viewBox="0 0 24 24"
              class="poketwitch__header-btn--inventory-inventory"
          >
            <path
                fill="currentColor"
                d="M16,5V4A2,2 0 0,0 14,2H10A2,2 0 0,0 8,4V5A4,4 0 0,0 4,9V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V9A4,4 0 0,0 16,5M10,4H14V5H10V4M12,9L14,11L12,13L10,11L12,9M18,16H9V18H8V16H6V15H18V16Z"
            />
          </svg>
        </button>

        <!-- battle button -->
        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--battle"
            v-bind:title="translation.general.searchBattle"
            @click="setBattleSlotView"
            :disabled="isLoading || isBlocked || currentView === BattleSlotPanel"
        >
          <svg
              style="width: 27px; height: 27px"
              viewBox="0 0 24 24"
              class="poketwitch__header-btn--battle-sword-left"
          >
            <path
                fill="currentColor"
                d="M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z"
            />
          </svg>

          <svg
              style="width: 27px; height: 27px"
              viewBox="0 0 24 24"
              class="poketwitch__header-btn--battle-sword-right"
          >
            <path
                fill="currentColor"
                d="M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z"
            />
          </svg>
        </button>

        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--pokedex"
            title="Pokedex"
            :disabled="isLoading || isBlocked || currentView === Pokedex"
            @click="setPokedexView"
        >
          <svg
              style="width: 27px; height: 27px"
              viewBox="0 0 24 24"
              class="poketwitch__header-btn--pokedex-pokedex"
          >
            <path
                fill="currentColor"
                d="M17.5 14.33C18.29 14.33 19.13 14.41 20 14.57V16.07C19.38 15.91 18.54 15.83 17.5 15.83C15.6 15.83 14.11 16.16 13 16.82V15.13C14.17 14.6 15.67 14.33 17.5 14.33M13 12.46C14.29 11.93 15.79 11.67 17.5 11.67C18.29 11.67 19.13 11.74 20 11.9V13.4C19.38 13.24 18.54 13.16 17.5 13.16C15.6 13.16 14.11 13.5 13 14.15M17.5 10.5C15.6 10.5 14.11 10.82 13 11.5V9.84C14.23 9.28 15.73 9 17.5 9C18.29 9 19.13 9.08 20 9.23V10.78C19.26 10.59 18.41 10.5 17.5 10.5M21 18.5V7C19.96 6.67 18.79 6.5 17.5 6.5C15.45 6.5 13.62 7 12 8V19.5C13.62 18.5 15.45 18 17.5 18C18.69 18 19.86 18.16 21 18.5M17.5 4.5C19.85 4.5 21.69 5 23 6V20.56C23 20.68 22.95 20.8 22.84 20.91C22.73 21 22.61 21.08 22.5 21.08C22.39 21.08 22.31 21.06 22.25 21.03C20.97 20.34 19.38 20 17.5 20C15.45 20 13.62 20.5 12 21.5C10.66 20.5 8.83 20 6.5 20C4.84 20 3.25 20.36 1.75 21.07C1.72 21.08 1.68 21.08 1.63 21.1C1.59 21.11 1.55 21.12 1.5 21.12C1.39 21.12 1.27 21.08 1.16 21C1.05 20.89 1 20.78 1 20.65V6C2.34 5 4.18 4.5 6.5 4.5C8.83 4.5 10.66 5 12 6C13.34 5 15.17 4.5 17.5 4.5Z"
            />
          </svg>
        </button>

        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--mission"
            title="Missions"
            :disabled="isLoading || isBlocked || currentView === Mission"
            @click="setMissionView"
        >
          <svg
              style="width: 27px; height: 27px"
              viewBox="0 0 24 24"
              class="poketwitch__header-btn--mission-mission"
          >
            <path
                fill="currentColor"
                d="M4 3C2.89 3 2 3.89 2 5V9C2 10.11 2.89 11 4 11H8C9.11 11 10 10.11 10 9V5C10 3.89 9.11 3 8 3M8.2 4.5L9.26 5.55L5.27 9.5L2.74 6.95L3.81 5.9L5.28 7.39M4 13C2.89 13 2 13.89 2 15V19C2 20.11 2.89 21 4 21H8C9.11 21 10 20.11 10 19V15C10 13.89 9.11 13 8 13M4 15H8V19H4M12 5H22V7H12M12 19V17H22V19M12 11H22V13H12Z"
            />
          </svg>
        </button>

        <img
            v-if="!isLoading & !isBlocked"
            src="@/assets/img/logo.png"
            alt="PCG Logo"
            class="poketwitch__header-logo"
            @click="
            showFollowUsModal = true;
            remove_notification();
          "
        />
        <img
            v-else
            src="@/assets/img/logo.png"
            alt="PCG Logo"
            class="poketwitch__header-logo"
            style="opacity: 0.4"
        />
        <div v-if="newNotification" class="notification-icon">1</div>

        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--refresh"
            title="Refresh"
            @click="refreshView"
            :disabled="isLoading || isBlocked"
            :style="refreshButtonStyle"
        >
          <svg
              class="bi bi-arrow-clockwise"
              width="27px"
              height="27px"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                fill-rule="evenodd"
                d="M3.17 6.706a5 5 0 0 1 7.103-3.16.5.5 0 1 0 .454-.892A6 6 0 1 0 13.455 5.5a.5.5 0 0 0-.91.417 5 5 0 1 1-9.375.789z"
            />
            <path
                fill-rule="evenodd"
                d="M8.147.146a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 1 1-.707-.708L10.293 3 8.147.854a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </button>
      </div>

      <div v-else class="text-center pcg-app-nav-container">
        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--pokelist"
            @click="
            battleContent = {
              ...battleContent,
              speed: 10,
            };
            isPause = false;
          "
            :disabled="battleContent['speed'] === 10"
        >
          <svg
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
              id="speed-slow-button"
          >
            <path
                fill="currentColor"
                d="M12 16C13.66 16 15 14.66 15 13C15 11.88 14.39 10.9 13.5 10.39L3.79 4.77L9.32 14.35C9.82 15.33 10.83 16 12 16M12 3C10.19 3 8.5 3.5 7.03 4.32L9.13 5.53C10 5.19 11 5 12 5C16.42 5 20 8.58 20 13C20 15.21 19.11 17.21 17.66 18.65H17.65C17.26 19.04 17.26 19.67 17.65 20.06C18.04 20.45 18.68 20.45 19.07 20.07C20.88 18.26 22 15.76 22 13C22 7.5 17.5 3 12 3M2 13C2 15.76 3.12 18.26 4.93 20.07C5.32 20.45 5.95 20.45 6.34 20.06C6.73 19.67 6.73 19.04 6.34 18.65C4.89 17.2 4 15.21 4 13C4 12 4.19 11 4.54 10.1L3.33 8C2.5 9.5 2 11.18 2 13Z"
            />
          </svg>
        </button>

        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--inventory"
            @click="
            battleContent = {
              ...battleContent,
              speed: 5,
            };
            isPause = false;
          "
            :disabled="battleContent['speed'] === 5"
        >
          <svg
              style="width: 24px; height: 24px"
              viewBox="0 0 24 24"
              id="speed-medium-button"
          >
            <path
                fill="currentColor"
                d="M12 1.38L9.14 12.06C8.8 13.1 9.04 14.29 9.86 15.12C11.04 16.29 12.94 16.29 14.11 15.12C14.9 14.33 15.16 13.2 14.89 12.21M14.6 3.35L15.22 5.68C18.04 6.92 20 9.73 20 13C20 15.21 19.11 17.21 17.66 18.65H17.65C17.26 19.04 17.26 19.67 17.65 20.06C18.04 20.45 18.68 20.45 19.07 20.07C20.88 18.26 22 15.76 22 13C22 8.38 18.86 4.5 14.6 3.35M9.4 3.36C5.15 4.5 2 8.4 2 13C2 15.76 3.12 18.26 4.93 20.07C5.32 20.45 5.95 20.45 6.34 20.06C6.73 19.67 6.73 19.04 6.34 18.65C4.89 17.2 4 15.21 4 13C4 9.65 5.94 6.86 8.79 5.65"
            />
          </svg>
        </button>

        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--battle"
            @click="
            battleContent = {
              ...battleContent,
              speed: 1,
            };
            isPause = false;
          "
            :disabled="battleContent['speed'] === 1"
        >
          <svg
              style="width: 24px; height: 24px; transform: rotate(-45deg)"
              viewBox="0 0 24 24"
              id="speed-fast-button"
          >
            <path
                fill="currentColor"
                d="M12,16A3,3 0 0,1 9,13C9,11.88 9.61,10.9 10.5,10.39L20.21,4.77L14.68,14.35C14.18,15.33 13.17,16 12,16M12,3C13.81,3 15.5,3.5 16.97,4.32L14.87,5.53C14,5.19 13,5 12,5A8,8 0 0,0 4,13C4,15.21 4.89,17.21 6.34,18.65H6.35C6.74,19.04 6.74,19.67 6.35,20.06C5.96,20.45 5.32,20.45 4.93,20.07V20.07C3.12,18.26 2,15.76 2,13A10,10 0 0,1 12,3M22,13C22,15.76 20.88,18.26 19.07,20.07V20.07C18.68,20.45 18.05,20.45 17.66,20.06C17.27,19.67 17.27,19.04 17.66,18.65V18.65C19.11,17.2 20,15.21 20,13C20,12 19.81,11 19.46,10.1L20.67,8C21.5,9.5 22,11.18 22,13Z"
            />
          </svg>
        </button>

        <button
            v-if="!isPause"
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--mission"
            @click="
            battleContent['speed'] = 999999;
            isPause = true;
          "
            :disabled="battleContent['speed'] === 999999"
        >
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M15,16H13V8H15M11,16H9V8H11M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
            />
          </svg>
        </button>
        <button
            v-else
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--mission"
            @click="
            battleContent['speed'] = 5;
            isPause = false;
          "
        >
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
            />
          </svg>
        </button>

        <img
            v-if="!isLoading & !isBlocked"
            src="@/assets/img/logo.png"
            alt="PCG Logo"
            class="poketwitch__header-logo"
            @click="
            showFollowUsModal = true;
            remove_notification();
          "
        />
        <img
            v-else
            src="@/assets/img/logo.png"
            alt="PCG Logo"
            class="poketwitch__header-logo"
            style="opacity: 0.4"
        />
        <div v-if="newNotification" class="notification-icon">1</div>

        <button
            class="btn btn-link poketwitch__header-btn poketwitch__header-btn--refresh"
            title="Refresh"
            @click="exitBattleSpectate()"
        >
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z"
            />
          </svg>
        </button>
      </div>
    </header>

    <div class="poketwitch__content-wrapper">
      <Modal :is-open="showFollowUsModal" :closeable="false">
        <div
            v-if="eventContent.msg.length > 0 && eventContent.link.length > 0"
            style="text-align: center; border: 2px solid; margin: auto"
            class="followUsBox"
        >
          <h5>
            {{ eventContent.title }}
          </h5>
          <div>
            {{ eventContent.msg }}
          </div>

          <br/>
          <a :href="eventContent.link" target="_blank">
            <button
                style="
                width: 70%;
                height: 40px;
                background: #ff444b;
                color: white;
              "
                class="btn"
            >
              Find out more on discord!
            </button>
          </a>
          <br/>
          <br/>
        </div>

        <div class="followUsBox" style="margin-top: 8px">
          <div class="followUsBox-background"></div>

          Support us by following us on Twitch and receive up to 10% extra
          pokemoney <br/>
          <div style="width: 70%; margin: auto; margin-top: 10px">
            <a href="https://twitch.tv/jonaswagern" target="_blank">
              <button
                  style="
                  width: 100%;
                  height: 45px;
                  background: #ff444b;
                  color: white;
                "
                  class="btn"
              >
                Jonaswagern (+5%)
              </button>
            </a>
            <br/>
            <br/>
            <a href="https://twitch.tv/deemonrider" target="_blank">
              <button
                  style="
                  width: 100%;
                  height: 50px;
                  background: #ff444b;
                  color: white;
                "
                  class="btn"
              >
                DeemonRider (+5%)
              </button>
            </a>
          </div>
          <br/>
        </div>

        <template #footer>
          <button
              type="button"
              class="btn btn-secondary"
              @click="showFollowUsModal = false"
          >
            {{ translation.general.cancel }}
          </button>
        </template>
      </Modal>

      <scrollbars>
        <component :is="currentView" ref="currentViewComponent"/>
      </scrollbars>
    </div>

    <modal shows-msg :is-open="msgModalIsOpen" :closeable="false">
      <template #footer>
        <button
            type="button"
            class="btn btn-secondary"
            @click="msgModalIsOpen = false"
        >
          {{ translation.general.close }}
        </button>
      </template>
    </modal>

    <loading-overlay/>
  </div>
</template>

<script>
import {backendUri, firstView} from "./utils/settings";
import {battleContent, currentView} from "@/utils/globals";
import {language, translation} from "./utils/translations";
import axios from "axios";
import {ref} from "@vue/reactivity";
import LoadingOverlay from "@/components/LoadingOverlay/LoadingOverlay";
import Scrollbars from "@/components/Scrollbars/Scrollbars";
import {
  isLoading,
  stopLoadingProcess,
} from "@/components/LoadingOverlay/loadingOverlayControl";
import {
  blockButton,
  isBlocked,
  unblockButton,
} from "@/components/ButtonControl/ButtonControl";
import Modal from "@/components/Modal/Modal";
import {msgModalIsOpen, showModalMsg} from "@/components/Modal/modalUtils";
import NoUserIdShared from "@/views/Errors/NoUserIdShared/NoUserIdShared";
import jwt from "jsonwebtoken";
import NotWhitelisted from "@/views/Errors/NotWhitelisted/NotWhitelisted";
import NotStarted from "@/views/Errors/NotStarted/NotStarted";
import PokemonList from "@/views/PokemonList/PokemonList";
import ItemList from "@/views/ItemList/ItemList";
import BattleSlotPanel from "@/views/Battle/BattleSlotPanel";
import axiosRetry from "axios-retry";
import Mission from "@/views/Mission/Mission";
import Battle from "@/views/Battle/Battle";
import {handleUnknownError} from "@/utils/utilities";
import Pokedex from "./views/Pokedex/Pokedex";
import Cache from "./cache";
import {useQueryClient} from "vue-query";
import ItemShop from "./views/ItemList/ItemShop";
import BattleItemShop from "./views/ItemList/BattleItemShop";
import {pcgThemeStyle, twitch_id, twitch_role} from "./utils/globals";


export default {
  name: "App",
  components: {
    Modal,
    Scrollbars,
    LoadingOverlay,
  },
  setup() {
    const queryClient = useQueryClient();

    axiosRetry(axios, {
      retries: 5,
      retryDelay: (retryCount) => {
        if (retryCount === 5) {
          showModalMsg(translation.general.connectionFailed);
          stopLoadingProcess();
        }
        return retryCount * 1000;
      },
      retryCondition: (error) => {
        if (error.response) {
          return ![400, 500].includes(error.response.status);
        }
        return true;
      },
    });

    const refreshButtonStyle = ref({});
    const currentViewComponent = ref();
    const isPause = ref(false);
    const showFollowUsModal = ref(false);
    const newNotification = ref(false);
    const eventContent = ref({link: "", msg: "", title: ""});

    const exitBattleSpectate = async () => {
      isPause.value = false;
      battleContent.value['isViewer'] = false;
      setBattleSlotView();
      unblockButton();
    };

    const changeView = async () => {
      currentViewComponent.value.changeView();
    };

    const setPokemonListView = async () => {
      blockButton();
      currentView.value = PokemonList;

      setTimeout(function () {
        unblockButton();
      }, 3000);
    };

    const setItemListView = async () => {
      blockButton();
      currentView.value = ItemList;
    };

    const setBattleSlotView = async () => {
      blockButton();
      currentView.value = BattleSlotPanel;

      setTimeout(function () {
        unblockButton();
      }, 3000);
    };

    const setMissionView = async () => {
      blockButton();
      currentView.value = Mission;

      setTimeout(function () {
        unblockButton();
      }, 3000);
    };

    const setPokedexView = async () => {
      blockButton();
      currentView.value = Pokedex;

      setTimeout(function () {
        unblockButton();
      }, 3000);
    };

    const refreshView = async () => {
      blockButton();
      setTimeout(function () {
        unblockButton();
      }, 3000);

      Cache.invalidateAll(queryClient);

      currentViewComponent.value.refreshView();
      if (eventContent.value.msg.length > 0) {
        await check_for_notification();
      }

      refreshButtonStyle.value = {
        transition: "all 1000ms ease",
        transform: "rotate(360deg)",
      };
      setTimeout(() => {
        refreshButtonStyle.value = {
          transition: "none",
          transform: "rotate(0deg)",
        };
        setTimeout(() => {
          refreshButtonStyle.value = {
            transition: "all 300ms ease",
          };
        }, 50);
      }, 1000);
    };

    // init axios & twitch auth
    const twitchToken = ref();
    const firstTwitchAuth = ref(true);

    axios.defaults.headers.common["Accept-Language"] = language;
    axios.interceptors.response.use(undefined, (err) => {
      if (err.response) {
        if (err.response.status === 400) {
          const errorCode = err.response.data.error;
          if (errorCode === -24) {
            // throw connection error when jwt token expired
            showModalMsg(translation.general.connectionFailed);
          } else if (errorCode === -20) {
            // no content
            handleUnknownError(err);
          } else if (errorCode === -22) {
            // no access granted
            handleUnknownError(err);
          } else if (errorCode === -21) {
            currentView.value = NotWhitelisted;
          } else if (errorCode === -23) {
            currentView.value = NotStarted;
          }
        }
      }
      return Promise.reject(err);
    });

    const check_for_notification = async () => {
      await axios
          .get(backendUri + "api/game/ext/trainer/notification/")
          .then((resp) => {
            if (resp.data.n === true) {
              newNotification.value = true;
            }
            eventContent.value["link"] = resp.data.link;
            eventContent.value["title"] = resp.data.title;
            eventContent.value["msg"] = resp.data.msg;
          })
          .catch((error) => {
            handleUnknownError(error);
          });
    };

    const remove_notification = async () => {
      await axios
          .post(backendUri + "api/game/ext/trainer/notification/")
          .then(() => {
            newNotification.value = false;
          })
          .catch((error) => {
            handleUnknownError(error);
          });
    };

    window.Twitch.ext.onAuthorized(function (auth) {
      const authData = jwt.decode(auth.token);
      if (!authData.user_id) {
        window.Twitch.ext.actions.requestIdShare();
        currentView.value = NoUserIdShared;
        // reset if user revokes permission
        firstTwitchAuth.value = true;
      } else {
        twitch_role.value = authData.role;
        twitch_id.value = authData.user_id;
        twitchToken.value = auth.token;
        axios.defaults.headers.common["Authorization"] = twitchToken.value;
        if (firstTwitchAuth.value) {
          currentView.value = firstView;
          firstTwitchAuth.value = false;

          check_for_notification();
        }
      }
    });

    return {
      twitchToken,
      currentView,
      currentViewComponent,
      refreshView,
      changeView,
      refreshButtonStyle,
      translation,
      isLoading,
      isBlocked,
      msgModalIsOpen,
      setPokemonListView,
      setItemListView,
      setBattleSlotView,
      setMissionView,
      battleContent,
      isPause,
      exitBattleSpectate,
      Battle,
      showFollowUsModal,
      newNotification,
      remove_notification,
      eventContent,
      setPokedexView,
      PokemonList,
      BattleItemShop,
      ItemShop,
      ItemList,
      BattleSlotPanel,
      Pokedex,
      Mission,
      pcgThemeStyle
    };
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style lang="scss">
@import "./scss/variables";

.poketwitch {
  font-family: "Marvel", sans-serif;

  &--dark {
    background-color: #2c2b2b;
  }

  h5,
  h3,
  h2,
  h1,
  h4 {
    font-family: "Josefin Sans", sans-serif;
  }

  & > header {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 10;

    div {
      padding: 5px 5px 5px;
      font-family: "Josefin Sans", sans-serif;
      font-size: large;
      color: white;
      background-color: $poketwitch-branding-color;
      border-bottom: black 2px solid;
      box-shadow: black 0 0 3px;
    }
  }

  &__header-logo {
    position: relative;
    height: 50px;

    &--viewer {
      position: relative;
      height: 50px;
    }

    transition: all 500ms ease;
    cursor: pointer;

    &:hover {
      transform: rotate(-90deg);
    }
  }

  &__header-btn {
    position: absolute;
    color: white;
    padding: 2px;
    border-radius: 50px;
    top: 15px;

    &:disabled {
      color: #3c3f41;
    }

    &:focus {
      outline: 0 !important;
      box-shadow: none !important;
    }

    &--refresh {
      right: 15px;
      transition: all 300ms ease;

      &:hover {
        transform: rotate(-60deg);
      }
    }

    &--pokelist {
      left: 5vw;
      transition: all 300ms ease;

      svg {
        position: absolute;
        left: 0;
        transition: all 300ms ease;
      }

      &:hover &-pokelist {
        transform: rotate(30deg);
      }
    }

    &--inventory {
      left: 18vw;

      svg {
        position: absolute;
        left: 0;
        transition: all 300ms ease;
      }

      &:hover &-inventory {
        transform: rotate(30deg);
      }
    }

    &--battle {
      left: 35vw;
      top: 13px;
      margin-bottom: 5px;
      transition: all 300ms ease;
      transform: rotate(45deg);

      svg {
        position: absolute;
        left: 0;
        transition: all 150ms ease;
      }

      &:hover &-sword-left {
        transform: rotate(45deg);
      }

      &:hover &-sword-right {
        transform: rotate(-45deg);
      }
    }

    &--pokedex {
      left: 61vw;

      svg {
        position: absolute;
        left: 0;
        transition: all 300ms ease;
      }

      &:hover &-pokedex {
        transform: rotate(30deg);
      }
    }

    &--mission {
      left: 74vw;

      svg {
        position: absolute;
        left: 0;
        transition: all 300ms ease;
      }

      &:hover &-mission {
        transform: rotate(30deg);
      }
    }
  }

  &__content-wrapper {
    /* 62px is the height of the header */
    height: calc(100vh - #{$poketwitch-header-height});
    margin-top: $poketwitch-header-height;
  }
}

.followUsBox {
  text-align: center;
  border: 2px solid;
  border-radius: 15px;
  padding: 5px;

  &-background {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.1;

    background: url("views/PokemonList/img/pokeball-background.png") no-repeat center;
    left: 0;
    top: -6%;
    pointer-events: none;
  }
}

.notification-icon {
  position: absolute;
  color: #ffffff;
  background-color: rgb(252, 140, 0) !important;
  width: 19px;

  height: 19px;
  left: calc(50% + 12px);
  border-radius: 20px;
  font-size: small;
  top: 6px;
  pointer-events: none;
  padding: 0px !important;
  border-bottom: black 0px !important;
}
</style>
